
export enum ExportStatus {
    Pending = 1,
    Finished = 2,
    Cancelled = 3,
    Failed = 4,
    RejectedByUser = 5,
    Enabled = 6
}